/* eslint-disable eqeqeq */
/* eslint-disable no-var */
/* Disabled because var and != used by GTM script */
const {
  hasAcceptedCookies,
  cookieAcceptEventName,
} = require('@mondough/cookie-opt-in')

exports.onClientEntry = () => {
  const consentListeners = []

  const onConsentChange = () => {
    // get cookies
    const consent = {
      analytics_storage: hasAcceptedCookies('analytics'),
      ad_storage: hasAcceptedCookies('advertising'),
      personalization_storage: hasAcceptedCookies('personalisation'),
      functionality_storage: true,
      security_storage: true,
    }

    consentListeners.forEach((listenerFunction) => {
      try {
        listenerFunction(consent)
      } catch (error) {
        console.error(error)
      }
    })
  }

  const initialiseGTM = () => {
    const params = new URL(document.location).searchParams
    const isProd = window.location.hostname === 'monzo.com'
    const testProdinDev = params.get('uselivedata') === 'true'
    const GTMid = isProd || testProdinDev ? 'GTM-MRKTQTH' : 'GTM-MN9ZC4R'
    const GA4id = isProd || testProdinDev ? 'G-PRFK54V027' : 'G-QYEK3767SK'

    window.dataLayer = window.dataLayer || []

    // We set strict allow and deny policies in GTM
    // google is a class that covers Google's first party tools, like Tag Manager and Analytics
    // custom scripts and pixels are explicitly blocked, this may be revised as our GTM evolves (Cookie consent mode for example requires this.)
    // Allow/blocklist rules can be found here: https://developers.google.com/tag-platform/tag-manager/web/restrict
    // Consent mode uses sandboxedScripts, so we allow these.
    window.dataLayer.push({
      'gtm.allowlist': ['google', 'sandboxedScripts'],
      'gtm.blocklist': ['customScripts', 'customPixels'],
    })
    window.gtag = function gtag() {
      window.dataLayer.push(arguments)
    }
    ;(function (w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : ''
      j.async = true
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
      f.parentNode.insertBefore(j, f)
    })(window, document, 'script', 'dataLayer', GTMid)

    window.gtag('policy', 'all', function (containerId, permissionId, data) {
      const granted = true
      const denied = !granted
      // Only set policy for containers we use.
      // If it's a container we do not use, we deny it from running.
      if (containerId !== GTMid && containerId !== GA4id) {
        console.warn('denied container', containerId)
        return denied
      }
      // Since the policy is 'all', adjust permissions conditionally.
      switch (permissionId) {
        // https://developers.google.com/tag-platform/tag-manager/templates/permissions
        // We switch between the permissionID based on GTMs list and grant/deny [true/false]

        case 'access_consent': // Allows access to the user's consent for various cookie types.
        case 'get_cookies': // Reads the values of the cookies with the specified name.
          return granted

        case 'access_globals': // Allows access to a global variable (potentially including sensitive APIs).
        case 'access_local_storage': // Allows access to the specified keys in local storage.
        case 'access_template_storage': // Allows access to temporary storage for templates that can persist for the lifetime of the page.
        case 'get_referrer': // Permits read access to narrowed portions of the referrer.
        case 'get_url': // Returns part or all of the URL of the current page.
        case 'listen_data_layer': // Registers callbacks that listen for data layer events.
        case 'logging': // Logs to the developer console and GTM's preview mode.
        case 'read_data_layer': // Reads data from the dataLayer.
        case 'read_character_set': // Reads document.characterSet.
        case 'read_container_data': // Reads data about the container.
        case 'read_event_metadata': // Reads event metadata in Event Callbacks
        case 'read_title': // Reads document.title.
        case 'send_pixel': // Sends a GET request to a specified URL. Response is not processed.
        case 'set_cookies': // Sets a cookie with the specified name and parameters.
        case 'write_data_layer': // Writes data to the dataLayer.
        case 'inject_hidden_iframe': // Injects an invisible iframe with a given URL.
        case 'inject_script': // Injects a script into the page.
        default:
          console.error('denied', permissionId)
          // All unknown permissions are rejected.
          return denied
      }
    })
  }
  window.addConsentListener = (onUserConsent) => {
    consentListeners.push(onUserConsent)
    // if the user has already accepted cookies, call onConsentChange immediately
    if (hasAcceptedCookies()) {
      onConsentChange()
    }
  }
  initialiseGTM()

  // Remove the eventListener first to ensure it is only ever set once
  window.removeEventListener(cookieAcceptEventName, onConsentChange)
  window.addEventListener(cookieAcceptEventName, onConsentChange)
}

exports.onRouteUpdate = (state) => {
  const url = new URL(state.location.href)
  // remove the query params so we don't send anything we shouldn't to GA.
  url.search = ''
  window.gtag('set', 'page_path', url.pathname)
  window.gtag('event', 'page_view')
}
